export default __webpack_public_path__ + "app/build/static/media/flag_russia.9153130f.svg";